import { QhpSimple } from '@/fetching/sharedSchemas/basicSchemas';
import { getUserTimezone } from '@/utils/datetimes/timezone';

// Visit status codes.
// This is hard-coded into the back-end.
export const UNSCHEDULED_STATUS_CODE = 'UNSCHEDULED';
export const NOT_STARTED_STATUS_CODE = 'CONFIRMED';
export const EN_ROUTE_STATUS_CODE = 'EN_ROUTE';

// Visit outcome codes.
// This is hard-coded into the back-end.
export const NO_OUTCOME_CODE = 'NONE';

// This is hard-coded into the back-end.
export const UNASSIGNED_QHP_ID = 'None';

/** GraphQL takes null for an unassigned position instead of the sentinel id. */
export const toGraphqlClinicianId = (clinicianId: string): string | null =>
    clinicianId === UNASSIGNED_QHP_ID ? null : clinicianId;
export const UNASSIGNED_QHP_OBJECT: QhpSimple = {
    uuid: UNASSIGNED_QHP_ID,
    name: 'Unassigned',
    first_name: 'Unassigned',
    last_name: '',
    logo_url: null,
    timezone: getUserTimezone(),
    teams: [],
    address: null,
};

// This is not hard-coded into the backend. We wanted to create a generic object
// that would force users to make a selection in a select component. The 'NO_PROFESSIONAL_OBJECT'
// above is a valid, selectable option for 'Unassigned' visit positions, but we want to force
// the user to make a choice and to not have a default value.
export const PLEASE_SELECT_QHP_ID = 'Please Select';
export const PLEASE_SELECT_QHP_OBJECT: QhpSimple = {
    uuid: PLEASE_SELECT_QHP_ID,
    name: 'Please Select',
    first_name: 'Please Select a Clinician',
    last_name: '',
    logo_url: null,
    timezone: getUserTimezone(),
    teams: [],
    address: null,
};
